import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useChatbot } from '../../context/ChatbotContext';
import { SettingsTab } from '../../components/chatbot/tabs/SettingsTab';

const ChatbotSettingsPage: React.FC = () => {
  const { account, setAccount } = useChatbot();
  const navigate = useNavigate();

  return (
    <SettingsTab
      account={account}
      onUpdated={setAccount}
      onDeleted={() => navigate('/')}
    />
  );
};

export default ChatbotSettingsPage;
